import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const PortalDivider = ({ label = "STEP INTO THE BUILD", testid }) => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.5, 1, 0.8]);
    const opacity = useTransform(scrollYProgress, [0, 0.3, 0.7, 1], [0, 1, 1, 0]);

    return (
        <div ref={ref} className="pointer-events-none relative h-[36vh] overflow-hidden bg-omsivo-deep" aria-hidden data-testid={testid}>
            <motion.div style={{ scale, opacity }} className="absolute inset-0 flex items-center justify-center">
                <div className="relative flex h-[64%] w-[70%] max-w-xl items-center justify-center border border-flame/35"
                    style={{ boxShadow: "0 0 140px rgba(255,87,34,0.14) inset, 0 0 60px rgba(30,80,162,0.25)" }}>
                    <div className="absolute inset-3 border border-white/10" />
                    <div className="absolute inset-6 border border-white/5" />
                    <span className="absolute -left-px -top-px h-4 w-4 border-l-2 border-t-2 border-flame" />
                    <span className="absolute -right-px -top-px h-4 w-4 border-r-2 border-t-2 border-flame" />
                    <span className="absolute -bottom-px -left-px h-4 w-4 border-b-2 border-l-2 border-flame" />
                    <span className="absolute -bottom-px -right-px h-4 w-4 border-b-2 border-r-2 border-flame" />
                    <span className="bg-omsivo-deep/80 px-4 font-mono text-[10px] uppercase tracking-[0.4em] text-flame">
                        {label}
                    </span>
                </div>
            </motion.div>
        </div>
    );
};
